import { useState, useEffect, useMemo } from "react";
import { useAuthApi } from "../api/useAuthApi";
import { UserData } from "../types/auth-types";

export const useCurrentUser = () => {
  const [user, setUser] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(true);
  const { fetchAccountDetails } = useAuthApi();

  useEffect(() => {
    const loadUser = async () => {
      const stored = localStorage.getItem("account_details");
      if (stored) {
        try {
          setUser(JSON.parse(stored));
          setLoading(false);
          return;
        } catch (e) {
          console.error("Failed to parse stored user data", e);
        }
      }

      try {
        const response = await fetchAccountDetails();
        if (response?.data?.userData) {
          setUser(response.data.userData);
          localStorage.setItem("account_details", JSON.stringify(response.data.userData));
        }
      } catch (error) {
        console.error("Failed to fetch user details", error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [fetchAccountDetails]);

  return useMemo(() => ({ user, loading }), [user, loading]);
};
